var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisualisationFuzzyMatchAction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_17348_100406)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 32,
    height: 32,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9298 4.10051C14.5747 4.46473 13.7338 5.87338 14.0766 7.20168C14.4355 8.57284 15.8388 9.42446 17.1831 9.07631C18.5543 8.71745 19.4059 7.31416 19.0578 5.9805C18.6989 4.59327 17.2742 3.7363 15.9298 4.10051ZM16.9046 5.80375C17.4563 6.03406 17.5902 6.75177 17.1617 7.18026C16.5618 7.7855 15.5763 7.24453 15.7316 6.39827C15.8281 5.8948 16.4172 5.59486 16.9046 5.80375Z",
    fill: "#232F6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5048 5.80506C19.8728 6.07821 19.8406 7.00482 20.4459 7.35296C20.5262 7.40117 21.2118 7.42259 22.9954 7.44402L25.4324 7.4708L27.157 11.6753C28.1051 13.9891 28.8817 15.9388 28.8817 16.0137C28.8817 16.0887 28.1051 18.0383 27.157 20.3522L25.4324 24.5567L23.4131 24.5835C21.4796 24.6103 21.3886 24.6156 21.2493 24.7227C20.9654 24.9316 20.8797 25.103 20.8797 25.4404C20.8797 25.7779 20.9654 25.9493 21.2493 26.1582C21.3939 26.2653 21.4689 26.2706 23.7077 26.2867C24.9825 26.2974 26.1019 26.2867 26.1983 26.2706C26.6161 26.1957 26.6 26.2278 28.2711 22.125C29.1281 20.0308 29.8351 18.3222 29.8512 18.3222C29.8672 18.3222 30.5742 20.0308 31.4312 22.125C33.1023 26.2278 33.0862 26.1957 33.504 26.2706C33.6004 26.2867 34.527 26.2974 35.5661 26.2867C37.3711 26.2706 37.4568 26.2653 37.596 26.1582C37.8799 25.9493 37.9656 25.7779 37.9656 25.4404C37.9656 25.103 37.8799 24.9316 37.596 24.7227C37.4568 24.6156 37.3604 24.6103 35.8607 24.5835L34.2699 24.5567L32.5453 20.3522C31.5972 18.0383 30.8206 16.0887 30.8206 16.0137C30.8206 15.9388 31.5972 13.9891 32.5453 11.6753L34.2699 7.4708L35.8607 7.44402C37.3604 7.41723 37.4568 7.41188 37.596 7.30476C37.8799 7.09587 37.9656 6.92448 37.9656 6.58704C37.9656 6.24961 37.8799 6.07821 37.596 5.86933C37.4568 5.76221 37.3711 5.75685 35.5661 5.74078C34.527 5.73007 33.6004 5.74078 33.504 5.75685C33.0862 5.83183 33.1023 5.7997 31.4312 9.90246C30.5742 11.9967 29.8672 13.7053 29.8512 13.7053C29.8351 13.7053 29.1281 11.9967 28.2711 9.90781C27.1892 7.24048 26.6804 6.0675 26.5839 5.97645C26.509 5.90146 26.3804 5.81577 26.3001 5.78899C26.0591 5.69793 20.7137 5.714 20.5048 5.80506Z",
    fill: "#232F6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2202 22.9443C16.0006 23.0407 15.7756 23.3139 15.7382 23.5281C15.7221 23.6245 15.7114 24.5458 15.7221 25.5849C15.7382 27.3899 15.7435 27.4755 15.8506 27.6148C16.0595 27.8987 16.2309 27.9844 16.5683 27.9844C16.9058 27.9844 17.0772 27.8987 17.2861 27.6148C17.3932 27.4702 17.3985 27.4059 17.3985 25.4402C17.3985 23.4746 17.3932 23.4103 17.2861 23.2657C17.2271 23.1853 17.1147 23.0675 17.0397 23.0139C16.8629 22.88 16.4344 22.8425 16.2202 22.9443Z",
    fill: "#232F6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_17348_100406",
    x: -4,
    y: -14,
    width: 60,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_17348_100406"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.5525 0 0 0 0 0.56225 0 0 0 0 0.65 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_17348_100406",
    result: "effect2_dropShadow_17348_100406"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_17348_100406",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualisationFuzzyMatchAction);
export default __webpack_public_path__ + "static/media/visualisation-fuzzy-match-action.185d4bdc2b38792d7cf9312c4b64d285.svg";
export { ForwardRef as ReactComponent };